(function () {
  'use strict';
  var R = (window.ZOREX && window.ZOREX.routes) || {};
  var moneyFormat = (window.ZOREX && window.ZOREX.moneyFormat) || '${{amount_no_decimals_with_comma_separator}}';
  function money(cents) {
    var v = Math.round(cents) / 100;
    var s = v.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    if (/\{\{\s*amount\s*\}\}/.test(moneyFormat)) s = v.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return moneyFormat.replace(/\{\{\s*\w+\s*\}\}/, s);
  }

  /* ---------- Carrito lateral ---------- */
  function drawer() { return document.getElementById('zx-drawer'); }
  function openDrawer() { var d = drawer(); if (!d) return false; d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false'); document.documentElement.style.overflow = 'hidden'; return true; }
  function closeDrawer() { var d = drawer(); if (!d) return; d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); document.documentElement.style.overflow = ''; }
  function refreshDrawer() {
    return fetch((R.root || '/') + '?sections=zx-cart-drawer', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var html = j && j['zx-cart-drawer']; if (!html) return;
        var tmp = document.createElement('div'); tmp.innerHTML = html;
        var fresh = tmp.querySelector('#zx-drawer'); var cur = drawer();
        if (fresh && cur) { var wasOpen = cur.classList.contains('is-open'); cur.innerHTML = fresh.innerHTML; if (wasOpen) cur.classList.add('is-open'); }
      }).catch(function () {});
  }
  window.ZX_afterAdd = function () {
    if (document.body.classList.contains('template-cart')) { window.location.reload(); return; }
    refreshDrawer().then(openDrawer);
  };
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-drawer-close]')) { e.preventDefault(); closeDrawer(); return; }
    var op = e.target.closest('[data-drawer-open]');
    if (op && !document.body.classList.contains('template-cart') && drawer()) { e.preventDefault(); openDrawer(); return; }
    var ch = e.target.closest('[data-line-change]');
    if (ch) {
      e.preventDefault();
      ch.disabled = true;
      fetch((R.cartChange || '/cart/change') + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: ch.getAttribute('data-line-change'), quantity: parseInt(ch.getAttribute('data-qty-to'), 10) })
      }).then(function () { if (window.ZX_updateCartCount) window.ZX_updateCartCount(); return refreshDrawer(); });
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

  /* ---------- Ficha de producto ---------- */
  document.querySelectorAll('[data-product-section]').forEach(function (sec) {
    var form = sec.querySelector('form[data-ajax-cart]');
    var qty = sec.querySelector('[data-qty-input]');
    var addBtn = sec.querySelector('[data-add-btn]');
    var threshold = parseInt(sec.getAttribute('data-threshold') || '0', 10);
    var jsonEl = sec.querySelector('[data-product-json]');
    var product = null; try { product = JSON.parse(jsonEl.textContent); } catch (e) {}
    var idInput = form && form.querySelector('input[name=id]');
    function currentVariant() {
      if (!product) return null; var id = idInput ? parseInt(idInput.value, 10) : 0;
      return product.variants.find(function (v) { return v.id === id; }) || product.variants[0];
    }
    function q() { return Math.max(1, parseInt(qty && qty.value, 10) || 1); }
    function refresh() {
      var v = currentVariant(); if (!v) return;
      var n = q();
      if (addBtn && !addBtn.disabled) addBtn.textContent = addBtn.getAttribute('data-available').replace('[q]', n);
      // packs
      sec.querySelectorAll('[data-bundle]').forEach(function (b) {
        var bq = parseInt(b.getAttribute('data-bundle'), 10), off = parseFloat(b.getAttribute('data-off')) || 0;
        var total = v.price * bq * (100 - off) / 100;
        var t = b.querySelector('[data-bundle-total]'), u = b.querySelector('[data-bundle-unit]');
        if (t) t.textContent = money(total); if (u) u.textContent = money(total / bq) + ' c/u';
        var on = bq === n || (bq === 3 && n > 3);
        b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      // barra de envío gratis
      if (threshold > 0) {
        var bundleOff = 0; var sel = sec.querySelector('[data-bundle].is-on'); if (sel) bundleOff = parseFloat(sel.getAttribute('data-off')) || 0;
        var total2 = v.price * n * (100 - bundleOff) / 100;
        var left = threshold - total2;
        var msg = left <= 0 ? 'Tenés envío gratis' : 'Te faltan ' + money(left) + ' para el envío gratis';
        document.querySelectorAll('[data-ship-msg]').forEach(function (m) { m.textContent = msg; });
        var bar = sec.querySelector('[data-ship-bar]'); if (bar) bar.style.width = Math.min(100, Math.round(total2 / threshold * 100)) + '%';
      }
      var sp = document.querySelector('[data-sticky-price]'); if (sp) sp.textContent = money(v.price);
      var alert = sec.querySelector('[data-stock-alert]');
      if (alert && v.inventory_management === 'shopify' && typeof v.inventory_quantity === 'number') {
        var lim = parseInt(sec.getAttribute('data-low-stock') || '10', 10);
        alert.hidden = !(v.inventory_quantity > 0 && v.inventory_quantity <= lim);
      }
    }
    sec.addEventListener('click', function (e) {
      var b = e.target.closest('[data-bundle]'); if (!b) return;
      if (qty) { qty.value = b.getAttribute('data-bundle'); }
      refresh();
    });
    if (qty) { qty.addEventListener('change', refresh); qty.addEventListener('input', refresh); }
    sec.addEventListener('zx:variant', function () { setTimeout(refresh, 0); });
    refresh();

    // barra fija
    var sticky = document.querySelector('[data-sticky-buy]');
    var target = sec.querySelector('.buy');
    if (sticky && target && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var en = entries[0];
        sticky.classList.toggle('is-visible', !en.isIntersecting && en.boundingClientRect.top < 0);
      }).observe(target);
    }
    document.querySelectorAll('[data-sticky-add]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var f = document.getElementById(btn.getAttribute('data-sticky-add'));
        if (f) { if (f.requestSubmit) f.requestSubmit(); else f.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true })); }
      });
    });
  });

  /* ---------- Destacados que rotan ---------- */
  document.querySelectorAll('[data-spotlight]').forEach(function (sp) {
    var items = Array.prototype.slice.call(sp.querySelectorAll('[data-spot-item]'));
    if (items.length <= 3) return;
    var sec = parseInt(sp.getAttribute('data-interval') || '10', 10) * 1000, start = 0;
    setInterval(function () {
      start = (start + 3) % items.length;
      items.forEach(function (it) { it.hidden = true; });
      for (var i = 0; i < 3; i++) { var el = items[(start + i) % items.length]; el.hidden = false; el.style.animation = 'none'; void el.offsetWidth; el.style.animation = ''; }
    }, sec);
  });
})();
